import { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { TripsAppPage } from "@tenant/ui";
import { HomesReservationDetail } from "./HomesReservationDetail";
import styles from "./HomesReservationPage.module.scss";
import { useHomesReservationPage } from "./useHomesReservationPage";
import { PageLoadingScreen } from "@/overrides/core-ui/PageLoadingScreen/PageLoadingScreen";

export const HomesReservationPage = () => {
  const { reservation, isLoading } = useHomesReservationPage();
  const [block, cn] = useModuleBEM(styles, "HomesReservationPage");
  const { t } = useI18nContext();
  const navigate = useNavigate();

  const onQueryCancellation = useCallback(() => {
    navigate("cancel");
  }, [navigate]);

  if (isLoading || reservation == null) {
    return (
      <TripsAppPage className={block}>
        <PageLoadingScreen className="" isLoading text={t("fetchingTrips")} />
      </TripsAppPage>
    );
  }

  return (
    <TripsAppPage className={block} contentClassName={cn("content")}>
      <HomesReservationDetail
        reservation={reservation}
        onQueryCancellation={onQueryCancellation}
      />
    </TripsAppPage>
  );
};
